export const initiateAndActivateProgramEnrollmentDefault = '{\n' +
    '    "customerId": "",\n' +
    '    "drugId": "",\n' +
    '    "personId": ""\n' +
    '    "programName": ""\n' +
    '    "profileId": ""\n' +
    '    "scheduleFrequency": ""\n' +
    '}';

export interface IInitiateAndActivateProgramEnrollmentRequest {
    customerId: string
    drugId: string
    personId: string
    programName: string
    profileId: string
    scheduleFrequency: string
}
